module.exports = __webpack_public_path__ + "img/priceTagUp.1bef35a6.png";